import { useState } from 'react';

export default function Specifications() {
  const [showModal, setShowModal] = useState(false);

  const specifications = [
    {
      capacity: '0,5 т',
      height: '6 / 12 м',
      speed: '8 / 2 м/мин',
      voltage: '380 В',
      mode: 'ПВ 25%',
      control: 'Пульт',
      climate: 'У1'
    },
    {
      capacity: '1 т',
      height: '6 / 12 / 18 м',
      speed: '8 / 2 м/мин',
      voltage: '380 В',
      mode: 'ПВ 25%',
      control: 'Пульт',
      climate: 'У1'
    },
    {
      capacity: '2 т',
      height: '6 / 12 / 18 м',
      speed: '8 / 2 м/мин',
      voltage: '380 В',
      mode: 'ПВ 40%',
      control: 'Пульт / Радио',
      climate: 'У1'
    },
    {
      capacity: '3,2 т',
      height: '6 / 12 / 18 м',
      speed: '8 / 2 м/мин',
      voltage: '380 В',
      mode: 'ПВ 40%',
      control: 'Пульт / Радио',
      climate: 'У1'
    },
    {
      capacity: '5 т',
      height: '6 / 12 / 18 / 24 м',
      speed: '8 / 2 м/мин',
      voltage: '380 В',
      mode: 'ПВ 40%',
      control: 'Пульт / Радио',
      climate: 'У1'
    },
    {
      capacity: '10 т',
      height: '6 / 12 / 18 / 24 м',
      speed: '7 / 1,75 м/мин',
      voltage: '380 В',
      mode: 'ПВ 40%',
      control: 'Пульт / Радио',
      climate: 'У1'
    }
  ];

  return (
    <section id="specifications" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-10 lg:mb-12">Технические характеристики</h2>
        
        <div className="overflow-x-auto -mx-4 sm:mx-0">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden">
              <table className="min-w-full border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Грузоподъёмность
                    </th>
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Высота подъёма
                    </th>
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Скорость подъёма
                    </th>
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Напряжение
                    </th>
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Режим работы
                    </th>
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Тип управления
                    </th>
                    <th className="text-left px-3 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-700 uppercase border-b border-gray-200 whitespace-nowrap">
                      Климат. исполнение
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {specifications.map((spec, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.capacity}
                      </td>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.height}
                      </td>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.speed}
                      </td>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.voltage}
                      </td>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.mode}
                      </td>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.control}
                      </td>
                      <td className="px-3 sm:px-4 py-3 sm:py-4 text-sm sm:text-[15px] text-gray-900 border-b border-gray-200 whitespace-nowrap">
                        {spec.climate}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-8 sm:mt-10 px-4">
          <button 
            onClick={() => setShowModal(true)}
            className="bg-[#1A2B4A] text-white px-6 sm:px-10 h-[48px] sm:h-[52px] text-sm sm:text-base font-medium hover:bg-[#0F1A2E] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Получить точную спецификацию под задачу
          </button>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-white max-w-md w-full p-6 sm:p-8 relative my-8">
            <button 
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Запрос спецификации</h3>
            <p className="text-sm text-gray-500 mb-6">Укажите ваши контактные данные, и мы вышлем подробную спецификацию</p>
            
            <form 
              data-readdy-form
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.currentTarget);
                const data = new URLSearchParams();
                formData.forEach((value, key) => {
                  data.append(key, value.toString());
                });
                
                fetch('https://readdy.ai/api/form/d5j484qgbpr25eot4430', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: data.toString()
                }).then(() => {
                  alert('Спасибо! Мы свяжемся с вами в ближайшее время.');
                  setShowModal(false);
                  e.currentTarget.reset();
                }).catch(() => {
                  alert('Произошла ошибка. Попробуйте позже.');
                });
              }}
              className="space-y-5"
            >
              <input
                type="text"
                name="company"
                placeholder="Компания"
                required
                className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
              />
              <input
                type="text"
                name="contact"
                placeholder="Контактное лицо"
                required
                className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                required
                className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
              />
              <button 
                type="submit"
                className="w-full bg-[#1A2B4A] text-white h-[52px] text-base font-medium hover:bg-[#0F1A2E] transition-colors whitespace-nowrap cursor-pointer"
              >
                Отправить запрос
              </button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}